import {Transerializable, GetterConfigArgs, stringOr} from '@eventops/athlinks-get-or'
import {checkStringEnum} from '.'

export enum TimeUnit {
  HOURS = 'h',
  MILLI_SECONDS = 'ms',
  MINUTES = 'm',
  SECONDS = 's'
}

export interface ITime {
  timeInMillis: number,
  timeUnit: TimeUnit
}

export class Time extends Transerializable implements ITime {
  config: GetterConfigArgs = {
    optionalPartialConfig: {
      timeUnit: {
        getter: stringOr,
        decorators: (unit: string) => {
          if (!unit) {
            return TimeUnit.MILLI_SECONDS
          }
          if (!checkStringEnum(TimeUnit, unit)) {
            throw new Error(`Invalid time unit: ${unit}`)
          }
          return unit
        }
      }
    }
  }
  timeInMillis = -1
  timeUnit = TimeUnit.MILLI_SECONDS
}